import type { DocumentRef } from '../../lib/documentReader'
import { recordHref, workbenchHref, type ViewScope } from '../navigation/context'
import { recoveryHref } from './recovery'

export interface OtherItem {
  id: string
  kind: 'task' | 'reporting_setup' | 'reporting_period' | 'unclassified'
  label: string
  subject: string | null
  fund_ids: string[]
  task_id: string | null
  task_type: string | null
  priority: string | null
  target: { kind: 'entity' | 'instrument' | 'position' | 'trade'; id: string } | null
  documents: DocumentRef[]
  updated_at: string | null
  period_id: string | null
  as_of: string | null
  due_date: string | null
}
export interface OtherWork {
  items: OtherItem[]
  count: number
  complete: boolean
  coverage: 'current_retained_work'
}
export function otherCount(work: OtherWork | null | undefined): string {
  return work ? String(work.count) + (work.complete ? '' : '+') : '—'
}
export function otherType(item: OtherItem): string {
  if (item.kind === 'reporting_setup') return 'Reporting setup'
  if (item.kind === 'reporting_period') return 'Reporting period'
  if (item.task_type === 'look_through_review') return 'Look-through'
  if (item.task_type?.startsWith('verification_')) return 'Fund review'
  if (item.task_type?.endsWith('trade_missing')) return 'Missing movement'
  if (item.task_type === 'position_balance_stale') return 'Stale balance'
  return item.kind === 'task' ? 'Other review' : 'Work needing context'
}
export function otherHref(scope: ViewScope, item: OtherItem): string {
  if (
    item.kind === 'reporting_setup' ||
    item.kind === 'reporting_period' ||
    item.task_type === 'verification_signoff' ||
    item.task_type === 'verification_remediation'
  ) {
    const fund = item.fund_ids[0]
    if (fund)
      return (
        '/v2/funds/' +
        encodeURIComponent(fund) +
        (item.period_id ? '?reporting_period=' + encodeURIComponent(item.period_id) : '') +
        '#fund-reporting'
      )
  }
  if (item.kind === 'task' && item.task_id)
    return workbenchHref(scope, 'other') + '&item=' + encodeURIComponent(item.id)
  if (item.target) return recordHref(scope, { focus: item.target.kind + ':' + item.target.id })
  if (item.documents[0]) return '/v2/documents/' + encodeURIComponent(item.documents[0].document_id)
  return '/v2/traces'
}
export function otherRecoveryHref(scope: ViewScope, item: OtherItem): string {
  return recoveryHref(scope, item.task_id ?? undefined)
}
